import * as Constants from '../Constant';

const initialState = {
    message: {},
    clinicList: {},
}

export default function clinicReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_CLINIC:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_CLINIC:
            return {
                ...state,
                clinicList: action.payload,
            }
        case Constants.UPDATE_CLINIC:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_CLINIC:
            return {
                ...state,
                message: action.payload,
            }
        default:
            return state;
    }
}